import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// import { adminAPI } from '../../services/api';
// import { adminAPI } from '../../../services/api';
import { teacherAPI as adminAPI } from '../../../services/api';
import { toast } from 'react-hot-toast';

const StaffImportQuizQuestions = () => {
  const { quizId } = useParams();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    if (!selectedFile.name.endsWith('.cbthost')) {
      toast.error('Please select a .cbthost file exported from cbthost.com');
      return;
    }

    setFile(selectedFile);
    setPreview({
      name: selectedFile.name,
      size: (selectedFile.size / 1024).toFixed(2) + ' KB'
    });
  };

  const handleUpload = async () => {
    if (!file) {
      toast.error('Please select a file');
      return;
    }

    setLoading(true);
    try {
      await adminAPI.importQuizQuestions(quizId, file);
      toast.success('Questions imported successfully');
      navigate(`/teacher/quizzes/${quizId}`);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to import questions');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white rounded-xl shadow border border-gray-100">
        <div className="p-6 border-b border-gray-100">
          <div className="flex items-center gap-3 mb-2">
            <div className="w-10 h-10 bg-indigo-100 rounded-xl flex items-center justify-center">
              <svg className="w-5 h-5 text-indigo-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clipRule="evenodd"/>
              </svg>
            </div>
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Import Questions</h1>
              <p className="text-gray-600 text-sm">Upload a .cbthost package exported from cbthost.com</p>
            </div>
          </div>
        </div>

        <div className="p-6 space-y-6">
          <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-indigo-400 transition">
            <input
              type="file"
              id="file-upload"
              accept=".cbthost"
              onChange={handleFileChange}
              className="hidden"
            />
            <label htmlFor="file-upload" className="cursor-pointer block">
              <div className="text-4xl mb-4">📦</div>
              <p className="text-lg font-medium text-gray-700">Choose a .cbthost file</p>
              <p className="text-sm text-gray-500 mt-1">
                Upload a CBTHost package exported from cbthost.com
              </p>
              <p className="text-xs text-gray-400 mt-2">
                The file should contain questions in the standard CBTHost format
              </p>
            </label>
          </div>

          {preview && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
              <div className="flex items-center gap-3">
                <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4z" clipRule="evenodd"/>
                </svg>
                <div className="flex-1">
                  <p className="font-medium text-blue-900">{preview.name}</p>
                  <p className="text-sm text-blue-700">{preview.size}</p>
                </div>
              </div>
            </div>
          )}

          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <div className="flex gap-3">
              <svg className="w-5 h-5 text-yellow-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd"/>
              </svg>
              <div className="text-sm text-yellow-800">
                <p className="font-medium">Important:</p>
                <ul className="list-disc list-inside mt-1 space-y-1">
                  <li>The file must be a .cbthost package exported from cbthost.com</li>
                  <li>Questions will be imported with their options and correct answers</li>
                  <li>Existing questions will not be overwritten</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
            <button
              type="button"
              onClick={() => navigate(`/teacher/quizzes/${quizId}`)}
              className="px-6 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition"
            >
              Cancel
            </button>
            <button
              onClick={handleUpload}
              disabled={!file || loading}
              className="px-6 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition disabled:opacity-50 flex items-center gap-2"
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  Importing...
                </>
              ) : (
                'Import Questions'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffImportQuizQuestions;